import { range } from "lodash";

export const rangeString = (start, end) =>
  range(start, end + 1).map((n) => n.toString());
